import React, { useEffect, useState } from 'react';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import { getMediaByAuthor, deleteOwnPrescription } from '../Api/media';
import { Modal, Button } from 'antd';
import { Box } from '@mui/material';
import { toast } from 'react-toastify';

const styles = {
    container: {
        padding: '20px',
        maxWidth: '1200px',
        margin: '0 auto',
    },
    pageTitle: {
        marginBottom: '30px',
        padding: '15px 0',
        borderBottom: '1px solid #e0e0e0',
    },
    breadcrumb: {
        fontSize: '16px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    breadcrumbLink: {
        color: '#007bff',
        cursor: 'pointer',
        transition: 'color 0.3s',
    },
    breadcrumbSeparator: {
        color: '#6c757d',
    },
    breadcrumbCurrent: {
        color: '#6c757d',
    },
    section: {
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '20px',
    },
    refreshButton: {
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
    },
    th: {
        background: '#f8f9fa',
        padding: '12px',
        textAlign: 'left',
        fontWeight: '600',
        borderBottom: '2px solid #dee2e6',
    },
    td: {
        padding: '12px',
        borderBottom: '1px solid #dee2e6',
    },
    tr: {
        transition: 'background 0.2s',
    },
    trHover: {
        background: '#f1f3f5',
    },
    button: {
        padding: '6px 12px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'background 0.3s',
    },
    viewButton: {
        background: '#007bff',
        color: '#fff',
    },
    deleteButton: {
        background: '#dc3545',
        color: '#fff',
    },
    noData: {
        textAlign: 'center',
        padding: '20px',
        color: '#6c757d',
        fontStyle: 'italic',
    },
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '400px',
        background: '#fff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
};

function MyPrescription() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [prescriptions, setPrescriptions] = useState([]);
    const [selectedPrescription, setSelectedPrescription] = useState(null);
    const [open, setOpen] = useState(false);
    const userId = JSON.parse(localStorage.getItem('user_data'))?.id;

    useEffect(() => {
        fetchUserMedia();
    }, []);

    const fetchUserMedia = async () => {
        setLoading(true);
        try {
            const media = await getMediaByAuthor(userId, 1, 10);
            setPrescriptions(media.data);
            console.log(media.data);
        } catch (error) {
            console.error('Failed to fetch media:', error.message);
            toast.error('Failed to load prescriptions. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteClick = (prescription) => {
        setSelectedPrescription(prescription);
        setOpen(true);
    };

    const handleDelete = async () => {
        // BUG-3: this previously showed a success toast without calling any API, so
        // the file was never actually removed. It now calls a scoped endpoint that
        // can only delete a prescription belonging to the signed-in user.
        if (!selectedPrescription?.id) return;
        try {
            await deleteOwnPrescription(selectedPrescription.id);
            toast.success('Prescription deleted successfully');
            setOpen(false);
            setSelectedPrescription(null);
            fetchUserMedia();
        } catch (error) {
            toast.error(error.message || 'Failed to delete prescription');
        }
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedPrescription(null);
    };

    return (
        <div className="content-wrapper">
            <section className="my-prescription">
                <div style={styles.container}>
                    {loading ? (
                        <Loader />
                    ) : (
                        <div style={styles.section}>

                            <div style={styles.refreshButton}>
                                <Button
                                    style={{ ...styles.button, background: '#28a745', color: '#fff' }}
                                    onClick={fetchUserMedia}
                                    onMouseOver={(e) => (e.target.style.background = '#218838')}
                                    onMouseOut={(e) => (e.target.style.background = '#28a745')}
                                >
                                    Refresh Prescriptions
                                </Button>
                            </div>

                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        <th style={styles.th}>Prescription ID</th>
                                        <th style={styles.th}>Date (M/D/Y)</th>
                                        <th style={styles.th}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {prescriptions.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" style={styles.noData}>
                                                No prescriptions found
                                            </td>
                                        </tr>
                                    ) : (
                                        prescriptions.map((product) => (
                                            <tr
                                                key={product.id}
                                                style={styles.tr}
                                                onMouseOver={(e) => (e.currentTarget.style.background = styles.trHover.background)}
                                                onMouseOut={(e) => (e.currentTarget.style.background = 'transparent')}
                                            >
                                                <td style={styles.td}>{product.id}</td>
                                                <td style={styles.td}>{new Date(product.date).toLocaleDateString()}</td>
                                                <td style={styles.td}>
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        <a target="_blank" href={product.source_url} rel="noopener noreferrer">
                                                            <Button
                                                                style={{ ...styles.button, ...styles.viewButton }}
                                                                onMouseOver={(e) => (e.target.style.background = '#0056b3')}
                                                                onMouseOut={(e) => (e.target.style.background = '#007bff')}
                                                            >
                                                                View
                                                            </Button>
                                                        </a>
                                                        <Button
                                                            style={{ ...styles.button, ...styles.deleteButton }}
                                                            onClick={() => handleDeleteClick(product)}
                                                            onMouseOver={(e) => (e.target.style.background = '#c82333')}
                                                            onMouseOut={(e) => (e.target.style.background = '#dc3545')}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>

                            <Modal
                                open={open}
                                onCancel={handleClose}
                                footer={[
                                    <Button
                                        key="cancel"
                                        style={{ ...styles.button, background: '#6c757d', color: '#fff' }}
                                        onClick={handleClose}
                                        onMouseOver={(e) => (e.target.style.background = '#5a6268')}
                                        onMouseOut={(e) => (e.target.style.background = '#6c757d')}
                                    >
                                        Cancel
                                    </Button>,
                                    <Button
                                        key="delete"
                                        style={{ ...styles.button, ...styles.deleteButton }}
                                        onClick={handleDelete}
                                        onMouseOver={(e) => (e.target.style.background = '#c82333')}
                                        onMouseOut={(e) => (e.target.style.background = '#dc3545')}
                                    >
                                        Delete
                                    </Button>,
                                ]}
                            >
                                <Box style={styles.modal}>
                                    <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>
                                        Confirm Delete
                                    </h3>
                                    <p>
                                        Are you sure you want to delete prescription #{selectedPrescription?.id}?
                                    </p>
                                </Box>
                            </Modal>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default MyPrescription;